import { connect } from "react-redux";
import JobStaffList from "./jobs-staff-list";
import { onEdit, onDelete, onPagedListRequested } from "../actions";

const mapStateToProps = ({ jobs, profile, queue, organisations }) => ({
	currentUserId: profile.id,
	role: profile.role,
	hasNetwork: queue.hasNetwork,
	pagination: jobs.pagination,
	flags: jobs.flags,
	currentOrganisationGUID:
		organisations?.currentOrganisation?.id ||
		organisations?.currentOrganisation ||
		"",
});

const mapDispatchToProps = {
	onEdit,
	onDelete,
	onGetJobList: onPagedListRequested,
};

export default connect(mapStateToProps, mapDispatchToProps)(JobStaffList);
